import { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import { ucFirst } from '../../../utilities/helperUtility';
import Translation from '../../../utilities/localizationUtility';

export default class ComponentSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTo: false,
    };

    this.validate = this.validate.bind(this);
    this.onChange = this.onChange.bind(this);
    this.placeholder = this.placeholder.bind(this);
  }

  componentDidMount() {
    const { getValidationFn } = this.props;

    if (getValidationFn) {
      getValidationFn(this.validate);
    }
  }

  componentDidUpdate() {
    const { scrollTo } = this.state;

    if (scrollTo) {
      this.setState({ scrollTo: false });
      const tolltip = document.getElementsByClassName('error-tooltip')[0];

      if (tolltip) {
        tolltip.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'start',
        });
      }
    }
  }

  validate() {
    const { errorMessage, kind, onSetErrors } = this.props;
    const errors = [];
    const monoKind = ucFirst(kind).slice(0, -1);
    const selectedKind = `selected${monoKind}`;
    const selected = this.props[selectedKind]; // eslint-disable-line

    if (isEmpty(selected)) {
      this.setState({ scrollTo: true });
      onSetErrors(errorMessage);
      errors.push(errorMessage);
    }

    return errors;
  }

  onChange(id) {
    const { kind, setSelected, onSetErrors } = this.props;
    const data = this.props[kind]; // eslint-disable-line
    const currentItem = data.find((item) => item.id === id);

    if (id == null || id === '') {
      setSelected(null);

      if (kind === 'locations') {
        this.props.setTimeZone(window.bta.timeZone); // eslint-disable-line
      }
    } else if (currentItem) {
      setSelected(currentItem);
      onSetErrors(null);

      if (kind === 'locations') {
        this.props.setTimeZone(currentItem.timezone); // eslint-disable-line
      }
    }
  }

  placeholder() {
    const { kind } = this.props;
    const t = new Translation(this.props);

    return t.key(`${kind.slice(0, -1)}DropdownPrompt`) || `Select ${ucFirst(kind).slice(0, -1)}...`;
  }
}
